<template>
  <div class="error-container d-flex flex-column">
    <simple-header />
    <div class="error-content">
      <div class="row m-0">
        <div class="col-lg-4 image-col">
          <transition name="bounce" enter-active-class="bounceInLeft">
            <img
              v-if="showWithDelay"
              src="../assets/image/error_pages/500.png"
              alt="error"
            />
          </transition>
        </div>
        <transition name="bounce" enter-active-class="bounceInRight">
          <div v-if="showWithDelay" class="col-lg-8 text-col">
            <h1>Oops... Something went wrong.</h1>
            <p>An error occurred while processing the request.</p>
            <p>{{ message }}</p>
            <a class="error-btn px-3" @click="navigateToLanding()" role="link"
              >GO TO AUTODESK ONE HOME</a
            >
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
require("vue2-animate/dist/vue2-animate.min.css");
import SimpleHeader from "../components/SimpleHeader";
export default {
  name: "error",
  data() {
    return {
      showWithDelay: false
    };
  },
  components: {
    SimpleHeader
  },
  computed: {
    message() {
      return this.$route.params.message;
    }
  },
  mounted() {
    setTimeout(() => {
      this.showWithDelay = true;
    }, 500);
  },
  methods:{
    navigateToLanding(){
      location.href=LANDING_PAGE_URL;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ErrorPage.vue